import React from 'react';
import { VideoList } from 'components/video/VideoList';
import { VideoItem } from 'components/video/VideoItem';

export const Component = () => {
  const image = {
    url: '/static/images/alvotech-meeting.jpg',
    width: 100,
    height: 100,
  };

  return (
    <VideoList
      // embed={{ type: 'video', embedUrl: 'https://vimeo.com/346836128', html: '' }}
      // placeholder={image}
      title="Video list title"
      tagline="Video list tagline"
      text={
        <p>
          Discriptive text about this video section, someting short and sweet, catchy and neat.
          Three lines, four lines or more.
        </p>
      }
      isSlice
    >
      <VideoItem
        embed={{ type: 'video', embedUrl: 'https://vimeo.com/346836128', html: '' }}
        title="alvotech biopharmaceuticals"
        placeholder={image}
      />
      <VideoItem
        embed={{ type: 'video', embedUrl: 'https://vimeo.com/346836128', html: '' }}
        title="alvotech biopharmaceuticals"
        placeholder={image}
      />
      <VideoItem
        embed={{ type: 'video', embedUrl: 'https://vimeo.com/346836128', html: '' }}
        title="alvotech biopharmaceuticals"
        placeholder={image}
      />
      <VideoItem
        embed={{ type: 'video', embedUrl: 'https://vimeo.com/346836128', html: '' }}
        title="alvotech biopharmaceuticals"
        placeholder={image}
      />
      <VideoItem
        embed={{ type: 'video', embedUrl: 'https://vimeo.com/346836128', html: '' }}
        title="alvotech biopharmaceuticals"
        placeholder={image}
      />
      <VideoItem
        embed={{ type: 'video', embedUrl: 'https://vimeo.com/346836128', html: '' }}
        title="alvotech biopharmaceuticals"
        placeholder={image}
      />
      <VideoItem
        embed={{ type: 'video', embedUrl: 'https://vimeo.com/346836128', html: '' }}
        title="alvotech biopharmaceuticals"
        placeholder={image}
      />
    </VideoList>
  );
};
